import Vue from 'vue'

import 'normalize.css/normalize.css'// A modern alternative to CSS resets

import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import VCharts from 'v-charts'

import * as echarts from 'echarts';

import '@/styles/index.scss' // global css

import App from './App'
import router from './router'
import store from './store'
import options from './utils/options'
import utils from './utils/utils'

import '@/icons' // icon
import '@/permission' // permission control
import VueCropper from 'vue-cropper'


Vue.use(ElementUI, {
  size: 'medium'
})

Vue.use(VCharts)
Vue.use(VueCropper)

Vue.config.productionTip = false

Vue.prototype.$selectOptions = options;

Vue.prototype.$utils = utils;
Vue.prototype.$echarts = echarts;

// 正式环境清除所有console.log
if (process.env.NODE_ENV === 'production') {
  if (window) {
    window.console.log = function () {};
  }
}

// import Vconsole from 'vconsole';
// if (process.env.NODE_ENV === 'development') {
//   const VConsole = require('vconsole');
//   new VConsole();
// }
new Vue({
  el: '#app',
  router,
  store,
  template: '<App/>',
  components: { App }
})



// WEBPACK FOOTER //
// ./src/main.js